import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { QuestionTable } from '../../../../tables/question-table'

const Questions: React.FunctionComponent = observer(() => {
  const match = useRouteMatch<any>('/people/users/:id/questions')
  const userID = Number(match?.params?.id)

  const [tableHelper] = useState(
    new TableHelper('list_user_questions', 'questions', 'users', userID),
  )

  return <QuestionTable tableHelper={tableHelper} />
})

export const UsersQuestionsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Questions',
    path: `/people/users/${id}/questions`,
    component: () => <Questions />,
  }
}
